"use client";

import { OTPInputContext } from "input-otp";
import { forwardRef, useContext } from "react";

import cx from "classnames";

const InputOTPSlot = forwardRef(({ index, className, ...props }, ref) => {
  const inputOTPContext = useContext(OTPInputContext);
  const { char, hasFakeCaret, isActive } = inputOTPContext.slots[index];
  return (
    <div
      ref={ref}
      className={cx(
        "border-input border-supportiveDarkGray relative flex items-center justify-center border text-sm shadow-sm transition-all",
        isActive && "ring-icon-color z-10 ring-1",
        className
      )}
      {...props}
    >
      {char}
      {hasFakeCaret && (
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
          <div className="animate-caret-blink h-4 w-px bg-black duration-1000" />
        </div>
      )}
    </div>
  );
});
InputOTPSlot.displayName = "InputOTPSlot";

export default InputOTPSlot;
